import { array, string, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';

/**
 * "Show" filter for the Design Transactions report — a completion-state filter
 * whose values are option ids (`'completed'` | `'completed-at-least-once'`);
 * generic string in-filter shape like the other list filters. The `equalsType`
 * (`eq`/`ne`) + selected option(s) are translated to `IS NOT NULL` / `IS NULL`
 * conditions on the design-completed timestamps by the query builder.
 */
export const CompletionState = struct({
	equalsType: EqualsType,
	values: array(string),
});
